module.exports = __webpack_public_path__ + "img/ticketcz.d82ad35e.png";